(function () {
  const $buttons = document.querySelectorAll('.ndc-tr-body-copy-block a.load-more-content');
  if (!$buttons.length) { return; }

  $buttons.forEach(function(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = btn.getAttribute('data-content');
      const target = document.getElementById(targetId);
      target.classList.remove('d-none');
      btn.remove();
    });
  });
})();